import { type ReactElement, type ReactNode } from 'react'
import { useAppSelector } from '@/store'
import { selectEnvironment } from '@/store/hederaSettingsSlice'
import EvmWalletProvider from './EvmWalletProvider'
import HederaWalletProvider from './HederaWalletProvider'

type UnifiedWalletProviderProps = {
  children: ReactNode
}

const UnifiedWalletProvider = ({ children }: UnifiedWalletProviderProps): ReactElement => {
  const environment = useAppSelector(selectEnvironment)

  if (environment === 'hedera') {
    return <HederaWalletProvider>{children}</HederaWalletProvider>
  }

  return <EvmWalletProvider>{children}</EvmWalletProvider>
}

export default UnifiedWalletProvider
